import OrganiserAccordion from '../../../../organiser/OrganiserAccordion/OrganiserAccordion';

export default {

  name: 'event-detail-block',

  props: {
    block: {}
  },

  components: {
    'organiser-accordion': OrganiserAccordion
  },

  inject: [
    'pageBuilderChildData',
    'storageData'
  ],

  data () {
    return {
      OrganiserIsVisible: false
    };
  },

  computed: {
    currentDate: function () {
      return new Date();
    }
  }
};



// WEBPACK FOOTER //
// ./src/apps/booking/components/pageBuilder/pageBuilderBlock/types/eventDetailBlock/EventDetailBlock.js